import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "suggestions", "name", "lat", "lng"]

  connect() {
    this.searchTarget.addEventListener("input", this.autocomplete.bind(this))
  }

  autocomplete(event) {
    const query = event.target.value
    if (query.length < 3) {
      this.suggestionsTarget.innerHTML = ""
      return
    }
    fetch(`/locations/geocode?query=${encodeURIComponent(query)}`)
      .then(response => response.json())
      .then(data => {
        this.suggestionsTarget.innerHTML = ""
        data.forEach(loc => {
          const div = document.createElement("div")
          div.className = "list-group-item list-group-item-action"
          div.textContent = `${loc.name} (${loc.country})`
          div.addEventListener("click", () => {
            this.nameTarget.value = loc.name
            this.latTarget.value = loc.lat
            this.lngTarget.value = loc.lng
            this.suggestionsTarget.innerHTML = ""
          })
          this.suggestionsTarget.appendChild(div)
        })
      })
  }
}
